
const rts = {
  handleSet_organizationInfo: 'handleSet_organizationInfo',
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsOrganizationReducer = (state, action) => {

  const { type, dispatch } = action

  switch (type) {

    case rts.handleSet_organizationInfo:
      // from pojo/organizations...
      const { organizationInfo } = action
      const { organization } = organizationInfo
      const { districts, sports } = organization ?? {}
      return { ...state, ...organizationInfo, organization_data: organizationInfo, districts, sports }

    default:
      return { ...state }
  }
}

export const sportsOrganizationHandlers = (dispatch) => {
  return {
    handleSet_organizationInfo: (organizationInfo) => { dispatch({ type: rts.handleSet_organizationInfo, dispatch, organizationInfo }) },
  }
}

export const sportsOrganizationInitialState = (init_state) => {
  return { ...init_state, currents: {}, currentSidebars: {} }
};
